<app-modal *ngIf="deviceService.isDesktop()"
           [canClose]="false"
           (closed)="onClose()">
  <app-modal-body>
    <ng-container [ngTemplateOutlet]="contentRef"></ng-container>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="!deviceService.isDesktop()"
                  [titleVisible]="false" [withCloseButton]="true"
                  [customTitle]="'user-profile.promo-info.sign-lesson' | translate"
                  (closed)="onClose()">
  <app-mobile-modal-body>
    <div class="checkout-wizard-wrap">
      <ng-container [ngTemplateOutlet]="contentRef"></ng-container>
    </div>
  </app-mobile-modal-body>
</app-mobile-modal>

<ng-template #contentRef>
  <app-step-by-step-wizard [steps]="steps" [showHeader]="true" [showFooter]="true">
    <ng-container header-details>
      <app-school-header-details *ngIf="school" [school]="school"></app-school-header-details>
      <app-teacher-header-details *ngIf="!school" [teacher]="teacher"></app-teacher-header-details>
    </ng-container>

    <ng-container content>
      <ng-container [ngSwitch]="activeView">
        <ng-container *ngSwitchCase="'payment'">
          <app-payment-widget
            *ngIf="paymentOptions"
            [options]="paymentOptions" [payClicked]="payClicked" [needUpdate]="afterAddAccountNeedUpdate"
            (configured)="onPaymentConfigured($event)"
            (succeed)="onPaymentSucceed()"
            (failed)="onPaymentFailed($event)"
            (processing)="onPaymentProcessing($event)" (addAccount)="onAddAccount($event)"
          ></app-payment-widget>
        </ng-container>

        <ng-container *ngSwitchCase="'cant-buy-meeting'">
          <div>На этот митинг нельзя записаться. Написать школе / автору</div>
          <div>cant-buy-meeting</div>
        </ng-container>

        <ng-container *ngSwitchCase="'own-meeting'">
          <app-warning-own-meeting></app-warning-own-meeting>
        </ng-container>

        <ng-container *ngSwitchCase="'error'">
          <div>Какая-то ошибка</div>
          <div>error</div>
          <pre *ngIf="paymentProcessingError">{{ paymentProcessingError }}</pre>
          <pre *ngIf="errorMessage">{{ errorMessage }}</pre>
        </ng-container>
      </ng-container>

      <div style="font-size: 8px;" *ngIf="debug">
        <div>activeView = {{ activeView | json }}</div>
        <pre>paymentOptions = {{ paymentOptions | json }}</pre>
        <div>paymentConfigured = {{ paymentConfigured | json }}</div>
        <!--<pre>meeting.can = {{ meeting?.can | json }}</pre>-->
        <!--<pre>meeting.is = {{ meeting?.is | json }}</pre>-->
        <div *ngIf="paymentProcessingError">paymentProcessingError = {{ paymentProcessingError | json }}</div>
        <div *ngIf="errorMessage">errorMessage = {{ errorMessage | json }}</div>
        <div>canExecutePayment = {{ canExecutePayment() | json }}</div>
        <hr/>
        <pre>{{ steps?.dump | json }}</pre>
      </div>
    </ng-container>

    <ng-container footer-details>
      <app-meeting-footer-details *ngIf="meeting" [meeting]="meeting">
      </app-meeting-footer-details>
    </ng-container>

    <ng-container footer-actions>
      <app-pay-button *ngIf="steps.get('payment')?.active"
                    [state]="payButtonsState"
                    [startLabel]="'user-service-checkout-wizard.newpay' | translate: {'amount': totalAmount.format()}"
                    [closeLabel]="'user-service-checkout-wizard.close' | translate"
                    [cancelLabel]="'user-service-checkout-wizard.to-complete' | translate"
                    [retryLabel]="'user-service-checkout-wizard.try-again' | translate"
                    (start)="onStartPayment()"
                    (retry)="onRetryPayment()"
                    (cancel)="onClose()"
      ></app-pay-button>
    </ng-container>
  </app-step-by-step-wizard>
</ng-template>
<app-add-card-wizard-dialog *ngIf="openAddAccountModal" [providerId]="addAccountProviderId"
                            (closed)="onCloseAddAccount()"></app-add-card-wizard-dialog>
